import React from 'react';

export function LoadingOverlay({
  label = 'Загрузка…',
  fixed = false,
}: {
  label?: string;
  fixed?: boolean;
}) {
  return (
    <div style={{
      position: fixed ? 'fixed' : 'absolute',
      inset: 0,
      zIndex: fixed ? 10000 : 300,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: fixed ? 'var(--bg-app)' : 'color-mix(in srgb, var(--bg-app) 88%, transparent)',
      flexDirection: 'column',
      gap: 12,
    }}>
      <span style={{
        width: 28,
        height: 28,
        borderRadius: '50%',
        border: '3px solid var(--clay-400)',
        borderTopColor: 'transparent',
        display: 'inline-block',
        animation: 'kor-spin 0.7s linear infinite',
      }} />
      <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, color: 'var(--text-primary)' }}>{label}</span>
    </div>
  );
}
